import { FC, ReactNode } from 'react'

import { Box } from '@mantine/core'

const FeatureCardRightContent: FC<{ children: ReactNode }> = ({ children }) => {
  return <Box>{children}</Box>
}

FeatureCardRightContent.displayName = 'FeatureCardRightContent'

export default FeatureCardRightContent
